import React from 'react';
import mailIcon from '../assets/svg/mail_icon.svg';

export const Email = ({ value, mailToButton = true }) => {
	const format = (i) => typeof i === 'string' ? i.toLowerCase() : i;

	return (
		<>
			{value && mailToButton && (
				<>
					<a href={`mailto:${value}`} target="_blank" rel="noopener noreferrer">
						<img src={mailIcon} alt="email icon" height={15} />
					</a>
					{' '}
				</>
			)}

			{format(value)}
		</>
	);
};

export default Email;
